/* eslint-disable react/prop-types */
import React, {useEffect, useState} from 'react';

import classNames from 'classnames';

import {AddAssessmentHeaderContainer} from './elements';
import BackIcon from '../../../../../../assets/icons/arrow_left.svg';
import CheckFillIcon from '../../../../../../assets/icons/tas-check-fill.svg';
import {MoreOptions} from '../../../../../../components/common';
import {DropdownItem} from '../../../../../../components/common/MoreOptions/components';
import {DeleteModal} from './components';

const DELAY = 500;

export const AddAssessmentHeader = ({
  currentTab,
  setCurrentTab,
  assessmentName,
  isPublished,
  assessmentId,
  // tabSwitchOnClick,
  isArchive,
  isTabSwitch,
  isSaveClicked,
  onDeleteAssessment,
  isDeleteLoading,
  onBack,
}) => {
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentTab]);

  return (
    <AddAssessmentHeaderContainer>
      <div className="view-assessment-nav">
        <div className="header-top">
          <div className="left-head">
            <button onClick={onBack} type="button" className="go-back-btn">
              <img
                alt="Back Button"
                className="header_t-back-icon"
                src={BackIcon}
              />
            </button>
            <div className="assessment-head">
              <div>{assessmentName}</div>
              <div className="search-div">
                <button
                  className={
                    currentTab === 'details' ? 'buttom link' : 'buttom'
                  }
                  type="button"
                  onClick={() => {
                    setCurrentTab('details');
                  }}
                >
                  {isSaveClicked && currentTab === 'tasks' ? (
                    <img
                      src={CheckFillIcon}
                      alt="check"
                      className="check-fill-icon mr-2"
                    />
                  ) : (
                    <span
                      className={classNames('mr-2 count', {
                        'is-current': currentTab === 'details',
                      })}
                    >
                      1
                    </span>
                  )}
                  <p>Basic Details</p>
                </button>
                <button
                  disabled={!isSaveClicked}
                  className={currentTab === 'tasks' ? 'buttom link' : 'buttom'}
                  type="button"
                  onClick={() => {
                    if (isSaveClicked && isTabSwitch()) {
                      // tabSwitchOnClick();
                      setCurrentTab('tasks');
                    }
                  }}
                >
                  <span
                    className={classNames('mr-2 count', {
                      'is-current': currentTab === 'tasks',
                    })}
                  >
                    2
                  </span>
                  <p>Task & Instruction</p>
                </button>
              </div>
            </div>
          </div>
          <DeleteModal
            isButtonLoading={isDeleteLoading}
            loadingButtonLabel="Deleting"
            onButtonClick={() => {
              onDeleteAssessment(deleteId, deleteName);
            }}
            onHide={() => {
              setDeleteId(null);

              setTimeout(() => {
                setDeleteName('');
              }, DELAY);
            }}
            show={!!deleteId}
            title={`Delete ${deleteName}`}
          />
          {!isPublished ? (
            <MoreOptions
              className={classNames('delete-assessement', {
                'is-archive': isArchive,
              })}
            >
              <DropdownItem
                isDanger
                label="Delete"
                onClick={() => {
                  setDeleteId(assessmentId);
                  setDeleteName(assessmentName);
                }}
              />
            </MoreOptions>
          ) : null}
        </div>
      </div>
    </AddAssessmentHeaderContainer>
  );
};
